import React from "react";
import dataSuccess from "../../data/dataSuccess";
import NavSuccess from "./NavSuccess";
import SuccessTemplateSidebar from "./SuccessTemplateSidebar";
import FileUploaderAuto from "./FileUploaderAuto";

class SuccessCopro extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const bgMobile = `url(${dataSuccess[this.props.success].imgMobile})`;
    return (
      <div className="flex-container">
        <SuccessTemplateSidebar
          success={this.props.success}
          lastStep={this.props.lastStep}
          codePromo={this.props.codePromo}
          handleCodePromo={this.props.handleCodePromo}
          validCodePromo={this.props.validCodePromo}
          resultCodePromo={this.props.resultCodePromo}
          isPrime={this.props.isPrime}
        >
          <div>
            <div className="success-item">
              <h3>Type de logement</h3>
              <h2>{this.props.Q2}</h2>
            </div>
          </div>
        </SuccessTemplateSidebar>

        <div className="success-right-container">
          <p className="mt-20 text-s" style={{ lineHeight: "1.1em" }}>
            Votre inscription est bien prise en compte. Nos experts Hellio se
            chargent de contacter votre syndic afin de présenter les différentes
            opportunités de rénovation énergétique pour votre copropriété.
          </p>
          {this.props.showFile && (
            <FileUploaderAuto
              patchName="fileImposition"
              description="Déposez votre avis imposition pour valider le montant de votre prime"
              handleFile={this.props.handleFile}
              result={this.props.result}
              firstname={this.props.contact.firstname}
              lastname={this.props.contact.lastname}
            ></FileUploaderAuto>
          )}
          <NavSuccess
            callBtn={this.props.callBtn}
            lastStep={this.props.lastStep}
            date={this.props.date}
            creneau={this.props.creneau}
            handleDate={this.props.handleDate}
            handleCreneau={this.props.handleCreneau}
          ></NavSuccess>
        </div>
        <div
          style={{
            backgroundImage: bgMobile,
          }}
          className="success-header-img only-show-mobile"
        >
          <h1>{dataSuccess[this.props.success].h1}</h1>
        </div>
      </div>
    );
  }
}

export default SuccessCopro;
